export default {"src":"/_next/static/media/search-icon.096f2007.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};